import React from 'react'
import { connect } from 'react-redux'
import TemplatesBase from './TemplatesBase'

import { set_path } from '../actions/'

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    setPath: path => dispatch( set_path(path) )
  }
}

class ConnectedTemplatesIndex extends React.Component {
  componentWillMount() {
    this.props.setPath('templates') // change depending on component
  }

  render() {
    return <TemplatesBase header="Templates" templatebase="index" />
  }
}

const TemplatesIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedTemplatesIndex)

export default TemplatesIndex



// WEBPACK FOOTER //
// ./src/js/components/TemplatesIndex.js